import moment from 'moment';
import { action, extendObservable } from 'mobx';
import FetchService from '../../../../core/services/FetchService';
import { get, orderBy, round, uniqBy, isNil } from 'lodash';
import { formatValueByIndicator, getColorByIndicatorAndValue, getGroupLabel } from './utils';

class ContentListService {
  fetchCurrent = new FetchService();
  fetchPrevious = new FetchService();

  constructor(indicator) {
    this.indicator = indicator;
    extendObservable(this, {
      current: [],
      previous: [],
    });
  }

  getChart = () => ({
    current: round(this.current.reduce((sum, x) => sum + x.value, 0) / this.current.length, 2),
    previous: round(this.previous.reduce((sum, x) => sum + x.value, 0) / this.previous.length, 2),
  });

  getList = () => {
    const groupArray = uniqBy(
      [...this.current, ...this.previous.map((item) => ({ ...item, totalAttempts: null, totalExecutions: null }))],
      'id'
    );

    return orderBy(
      groupArray.map((group) => {
        const current = this.current.find((item) => item.id === group.id);
        const previous = this.previous.find((item) => item.id === group.id);
        const totalAttempts = get(current, 'totalAttempts');
        const totalExecutions = get(current, 'totalExecutions');
        const currentValue = get(current, 'value');
        const previousValue = get(previous, 'value');
        return {
          ...group,
          totalAttempts: totalAttempts,
          totalExecutions: totalExecutions,
          current: isNil(currentValue) ? currentValue : round(currentValue, 2),
          previous: isNil(previousValue) ? previousValue : round(previousValue, 2),
        };
      }),
      ['name'],
      ['asc']
    );
  };

  getFormattedValue = (value) => formatValueByIndicator(this.indicator, value);

  getFeedbackColor = (value) => {
    return getColorByIndicatorAndValue(this.indicator, value);
  };

  getGroupLabel = getGroupLabel;

  load = action((type, typeId) => {
    this.fetchCurrent
      .fetch({
        url: `/kpis/content/${this.indicator.indexOf('UNIT') > -1 ? 'unit-item' : 'mastery-test-item'}/indicators/${
          this.indicator
        }/referenceMonth/${moment().subtract(1, 'months').format('YYYY-MM')}`,
        query: {
          ...(type && typeId ? { [type]: typeId } : {}),
        },
      })
      .then(() => {
        if (this.fetchCurrent.data) {
          this.current = this.fetchCurrent.data;
        } else {
          this.current = [];
        }
      });
    this.fetchPrevious
      .fetch({
        url: `/kpis/content/${this.indicator.indexOf('UNIT') > -1 ? 'unit-item' : 'mastery-test-item'}/indicators/${
          this.indicator
        }/referenceMonth/${moment().subtract(2, 'months').format('YYYY-MM')}`,
        query: {
          ...(type && typeId ? { [type]: typeId } : {}),
        },
      })
      .then(() => {
        if (this.fetchPrevious.data) {
          this.previous = this.fetchPrevious.data;
        } else {
          this.previous = [];
        }
      });
  });
}

export const ContentCourseFailureAttemptRateListService = new ContentListService(
  'UNIT_ITEM_EXECUTION_FAILURE_ATTEMPT_RATE'
);
export const ContentCourseRepeatRateListService = new ContentListService('UNIT_ITEM_EXECUTION_REPEAT_RATE');
export const ContentCourseSpeechRateListService = new ContentListService('UNIT_ITEM_EXECUTION_SPEECH_RATE');
export const ContentCourseErrorRateListService = new ContentListService('UNIT_EXECUTION_ERROR_RATE');
export const ContentMasteryFailureAttemptRateListService = new ContentListService(
  'MASTERY_TEST_ITEM_EXECUTION_FAILURE_ATTEMPT_RATE'
);
export const ContentMasteryRepeatRateListService = new ContentListService('MASTERY_TEST_ITEM_EXECUTION_REPEAT_RATE');
export const ContentMasterySpeechRateListService = new ContentListService('MASTERY_TEST_ITEM_EXECUTION_SPEECH_RATE');
export const ContentMasteryErrorRateListService = new ContentListService('MASTERY_TEST_EXECUTION_ERROR_RATE');
